export {};
//# sourceMappingURL=read-element-content-function.js.map